import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const TooltipText = ({ placement="top", text, children }) => {
  return (
    <OverlayTrigger
      animation={false}
      placement={placement}
      transition={false}
      overlay={
        <Tooltip id={"tooltip-key"} key={"tooltip-key"}>
          {text}
        </Tooltip>
      }
    >
      {children}
    </OverlayTrigger>
  );
};

export default TooltipText;
